import React from "react";
import "./KeySegments.scss";

const KeySegments = ({ data }) => {
  if (!data) return null;

  return (
    <div className="key-segments-section">
      <div className="key-segments-container">
        <div className="header">
          <span className="subtitle">{data.accentTitle}</span>
          <h2>{data.title}</h2>
          <p>{data.subTitle}</p>
        </div>

        <div className="segments-grid">
          {data.services?.map((service, index) => {
            // Check if it's the last item and the total count is odd to center it
            const isLastOdd =
              index === data.services.length - 1 &&
              data.services.length % 2 !== 0;
            return (
              <div
                key={index}
                className={`segment-card ${isLastOdd ? "centered-card" : ""}`}
              >
                <div className="card-content-left">
                  <span className="segment-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h4>{service.title}</h4>
                  <p>{service.subTitle}</p>
                  <div className="bg-icon">
                    <img src={service.titleImage} alt="" />
                  </div>
                </div>
                <div className="card-content-right">
                  <ul>
                    {service.points?.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default KeySegments;
